import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import React from 'react';

/**
 * Sets up a component to be consumed by Experience Builder. This function can be used to wrap a component with a container component, or to pass props to the component directly.
 * @param Component Component to be used by Experience Builder.
 * @param options Options for the `withComponentWrapper` function.
 * @default { wrapComponent: true, wrapContainerTag: 'div' }
 * @returns A component that can be passed to `defineComponents`.
 */
function withComponentWrapper(Component, options = {
    wrapComponent: true,
    wrapContainerTag: 'div',
    wrapContainer: 'div',
}) {
    const Wrapped = ({ classes = '', className = '', dragProps = {}, ...props }) => {
        const { innerRef, className: dragClassName, ToolTipAndPlaceholder, ...restOfDragProps } = dragProps;
        const component = options.wrapComponent ? (jsxs("div", { "data-component-wrapper": true, className: classNames(classes, className, dragClassName), ...restOfDragProps, ref: (refNode) => {
                if (innerRef && refNode)
                    innerRef(refNode);
            }, children: [ToolTipAndPlaceholder, jsx(Component, { className: classNames(classes), ...props })] })) : (React.createElement(Component, {
            className: classNames(classes, className),
            ...props,
        }));
        return component;
    };
    return Wrapped;
}

export { withComponentWrapper };
//# sourceMappingURL=withComponentWrapper.js.map
